import React, {  useState } from "react";
import HomeStyle from "./home.module.css";
import './text.css'
import { Carousel } from "antd";
import Icon, { LeftOutlined,RightOutlined } from '@ant-design/icons'; 
import { ReactComponent as GenomeIcon } from "./icon/无创基因.svg";
import { ReactComponent as TrainIcon } from "./icon/数据基因组.svg";
import { ReactComponent as MetabIcon } from "./icon/分子.svg";
import { ReactComponent as UserIcon } from "./icon/群体.svg";
import { ReactComponent as EpigIcon } from "./icon/endless.svg";
import { ReactComponent as ResourceIcon } from "./icon/Resource.svg";
import { ReactComponent as BookIcon } from "./icon/book.svg";
import { ReactComponent as Book1Icon } from "./icon/book_1.svg";
import { ReactComponent as FiveLineIcon } from "./icon/FiveLine.svg";
import { ReactComponent as ProjectIcon } from "./icon/project-fill.svg";
import { ReactComponent as DNAIcon } from "./icon/dna.svg";
import { ReactComponent as LeftIcon } from "../../assets/icon/Home/左边.svg";
import { ReactComponent as RightIcon } from "../../assets/icon/Home/右边.svg";

import ChinaMap3 from "./echarts/China/index3";
import { useNavigate } from "react-router-dom";

const contentStyle = {
  margin: 0,
  height: "400px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
};


function Home() {
  const navigate = useNavigate();

  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };
  const [IsChangeStyleOne, setIsChangeStyleOne] = useState(false);
  const [IsChangeStyleTwo, setIsChangeStyleTwo] = useState(false);
  const [IsChangeStyleThree, setIsChangeStyleThree] = useState(false);
  const [IsChangeStyleFour, setIsChangeStyleFour] = useState(false);
  const [IsChangeStyleFive, setIsChangeStyleFive] = useState(false);
  const customPrevArrow = (
    <div style={{ fontSize: "24px", color: "#fff", padding: "10px" }}>
      <LeftOutlined />
    </div>
  );

  const customNextArrow = (
    <div style={{ fontSize: "24px", color: "#fff", padding: "10px" }}>
      <RightOutlined />
    </div>
  );
 

  return (
    <div className={HomeStyle.Home_app}>
      <div className={HomeStyle.Home_Header}>
        <div className={HomeStyle.Home_left}>
          <Carousel afterChange={onChange} 
          arrows
          prevArrow={  <LeftIcon />}
          nextArrow={<RightIcon />}
          >
           <div>
              <h3 style={contentStyle} className={HomeStyle.Home_swiper_3}>
              {/* <img
                  src={require("../../assets/image/Home/滚动图片/03-栽培莲的分类.jpg")}
                  style={{ height:"400px",width:"100%",objectFit:"cover" }}
                  alt=""
                /> */}
              </h3>
            </div>
            <div>
              <h3 style={contentStyle}>
                <img
                  src={require("../../assets/image/Home/滚动图片/04-莲的组织介绍.jpg")}
                  style={{ height:"400px"}}
                  alt=""
                />
              </h3>
            </div>
            <div>
              <h3 style={contentStyle} className={HomeStyle.Home_swiper_1}>
                <img
                  src={require("../../assets/image/Home/滚动图片/01-中国古代莲.jpg")}
                  style={{ height:"400px" }}
                  alt=""
                />
              </h3>
            </div>
            <div>
              <h3 style={contentStyle} className={HomeStyle.Home_swiper_2}>
                <img
                  src={require("../../assets/image/Home/滚动图片/02-美洲黄莲.JPG")}
                  style={{ height:"400px" }}
                  alt=""
                />
              </h3>
            </div>
           
          </Carousel>
          <p
            style={{
              width: "100%",
              textAlign: "center",
              height: "15%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: "17px",
            }}
          >
          Welcome to Nelumbo Multi-omics Genome  Platform！
          </p>
        </div>
        <div className={HomeStyle.Home_right}>
          <p className={HomeStyle.responsive_text} id="responsive_text">
            Lotus, an economically important aquatic crop within the genus
            Nelumbo (family Nelumbonaceae), includes two extant species Nelumbo
            nucifera and Nelumbo lutea. The Nelumbo Multi-omics Genome Platform (NMGP) serves as a comprehensive platform that integrates
            multidimensional omics data with breeding applications. This
            database systematically consolidates genomic, transcriptomic,
            metabolomic, epigenomic, and genome-wide variation datasets, while
            also providing genomic selection-based breeding models and
            user-friendly bioinformatics analysis tools.
          </p>
        </div>
      </div>

      <div className={HomeStyle.Home_tools}>
        <div
          className={HomeStyle.Home_tools_item}
          style={{
            background: IsChangeStyleOne ? "#BDF7C1" : "#fff",
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/lotus/genomes/");
            sessionStorage.setItem("MenuKey", "3.1");
          }}
          onMouseEnter={() => {
            setIsChangeStyleOne(true);
          }}
          onMouseLeave={() => {
            setIsChangeStyleOne(false);
          }}
        >
          <GenomeIcon width={100} />
          <p>Genome</p>
        </div>
        <div
          className={HomeStyle.Home_tools_item}
          style={{
            background: IsChangeStyleFour ? "#BDF7C1" : "#fff",
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={() => {
            setIsChangeStyleFour(true);
          }}
          onMouseLeave={() => {
            setIsChangeStyleFour(false);
          }}
          onClick={() => {
            navigate("/lotus/structure/");
            sessionStorage.setItem("MenuKey", "6");
          }}
        >
          <UserIcon width={100} />
          <p>Populations</p>
        </div>
        <div
          className={HomeStyle.Home_tools_item}
          style={{
            background: IsChangeStyleTwo ? "#BDF7C1" : "#fff",
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={() => {
            setIsChangeStyleTwo(true);
          }}
          onMouseLeave={() => {
            setIsChangeStyleTwo(false);
          }}
          onClick={() => {
            navigate("/lotus/ranseq/");
            sessionStorage.setItem("MenuKey", "4");
          }}
        >
          <TrainIcon width={100} />
          <p>Transcriptome</p>
        </div>
        <div
          className={HomeStyle.Home_tools_item}
          style={{
            background: IsChangeStyleThree ? "#BDF7C1" : "#fff",
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={() => {
            setIsChangeStyleThree(true);
          }}
          onMouseLeave={() => {
            setIsChangeStyleThree(false);
          }}
          onClick={() => {
            navigate("/lotus/searchmetabolome/");
            sessionStorage.setItem("MenuKey", "5");
          }}
        >
          <MetabIcon width={100} />
          <p>Metabolome</p>
        </div>
        
        <div
          className={HomeStyle.Home_tools_item}
          style={{
            background: IsChangeStyleFive ? "#BDF7C1" : "#fff",
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={() => {
            setIsChangeStyleFive(true);
          }}
          onMouseLeave={() => {
            setIsChangeStyleFive(false);
          }}
          onClick={() => {
            navigate("/lotus/epigenome/");
            sessionStorage.setItem("MenuKey", "7");
          }}
        >
          <EpigIcon width={100} />
          <p>Epigenome</p>
        </div>
      </div>
      <div className={HomeStyle.Home_SpeciesDis}>
        <div className={HomeStyle.HomeSpeciesDis_left}>
          <p
            style={{
              width: "100%",
              height: "20%",
              fontWeight: "bold",
              color: "#2d7d2e",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 0 10px 0",
              textShadow: "0 2px 4px rgba(45, 125, 46, 0.1)",
              letterSpacing: "0.5px"
            }}
          >
            🌍 Species Distribution
          </p>
          <div className={HomeStyle.HomeSpeciesDis_left_map}>
            <ChinaMap3 />
            {/* <WordEcharts/> */}
          </div>
        </div>
        <div className={HomeStyle.Home_mainData_left}>
          <p
            style={{
              width: "100%",
              height: "20%",
              fontWeight: "bold",
              color: "#2d7d2e",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 0 10px 0",
              textShadow: "0 2px 4px rgba(45, 125, 46, 0.1)",
              letterSpacing: "0.5px"
            }}
          >
            📊 Data Statistics
          </p>
          <div className={HomeStyle.Home_mainData_left_content}>
            <div className={HomeStyle.Home_mainData_left_content_item}>
              <ResourceIcon width={32} style={{ marginBottom: "8px", color: "#5d9c5d" }} />
              <p style={{ margin: "0", fontSize: "14px", color: "#666", fontWeight: "500" }}>Resource</p>
              <p style={{ margin: "5px 0 0 0", fontSize: "24px", color: "#2d7d2e", fontWeight: "bold" }}>600+</p>
            </div>
            <div className={HomeStyle.Home_mainData_left_content_item}>
              <BookIcon width={32} style={{ marginBottom: "8px", color: "#5d9c5d" }} />
              <p style={{ margin: "0", fontSize: "14px", color: "#666", fontWeight: "500" }}>Projects</p>
              <p style={{ margin: "5px 0 0 0", fontSize: "24px", color: "#2d7d2e", fontWeight: "bold" }}>10+</p>
            </div>
            <div className={HomeStyle.Home_mainData_left_content_item}>
              <Book1Icon width={32} style={{ marginBottom: "8px", color: "#5d9c5d" }} />
              <p style={{ margin: "0", fontSize: "14px", color: "#666", fontWeight: "500" }}>Samples</p>
              <p style={{ margin: "5px 0 0 0", fontSize: "24px", color: "#2d7d2e", fontWeight: "bold" }}>1000+</p>
            </div>
            <div className={HomeStyle.Home_mainData_left_content_item}>
              <FiveLineIcon width={32} style={{ marginBottom: "8px", color: "#5d9c5d" }} />
              <p style={{ margin: "0", fontSize: "14px", color: "#666", fontWeight: "500" }}>Tools</p>
              <p style={{ margin: "5px 0 0 0", fontSize: "24px", color: "#2d7d2e", fontWeight: "bold" }}>6</p>
            </div>
            <div className={HomeStyle.Home_mainData_left_content_item}>
              <ProjectIcon width={32} style={{ marginBottom: "8px", color: "#5d9c5d" }} />
              <p style={{ margin: "0", fontSize: "14px", color: "#666", fontWeight: "500" }}>Tissues</p>
              <p style={{ margin: "5px 0 0 0", fontSize: "24px", color: "#2d7d2e", fontWeight: "bold" }}>18</p>
            </div>
            <div className={HomeStyle.Home_mainData_left_content_item}>
              <DNAIcon width={32} style={{ marginBottom: "8px", color: "#5d9c5d" }} />
              <p style={{ margin: "0", fontSize: "14px", color: "#666", fontWeight: "500" }}>Multi omics analysis</p>
              <p style={{ margin: "5px 0 0 0", fontSize: "24px", color: "#2d7d2e", fontWeight: "bold" }}>5</p>
            </div>
          </div>
        </div>
      </div>
      <div className={HomeStyle.Home_footer}>
        <p>
        Wuhan Botanical Garden, Chinese Academy of Sciences
        </p>
        <p>
        Add: No.201 Jiufeng 1 Road, East Lake High-Tech Development Zone, Wuhan, Hubei, P.R.China
        </p>
        <p>
        Postal Code: 430074
        </p>
        <p>
        E-mail: yangmei815815@wbgcas.cn
        </p>
        <p>
        Tel: +86-027-87700863
        </p>
      </div>
    </div>
  );
}

export default Home;
